import { call, put, all, takeLatest, spawn, select } from 'redux-saga/effects'
import Api from '../services/ApiManager'
import notification from '../../helpers/notification'
import { fillEntities } from '../actions/entityActions'
import { fillIntents } from '../actions/intentActions'
import { fillBotFlowsAction } from '../actions/flowActions'
import { Entity, Intent } from '../../model/intent/types'
import { Flow } from '../../model/workflowEditor/flow/types'
import {
    changeSelectedBotAction,
    exploreBotAction,
    saveBotAction,
} from '../actions/botActions'
import {
    BotActionTypes,
    saveBotActionType,
    exploreBotActionType,
    changeSelectedBotActionType,
    buildBotActionType,
} from '../../model/bot/actions'
import { navigate } from '@reach/router'
import { Bot } from '../../model/bot/types'
import { selectUserRoles } from '../selectors/userSelectors'
import { isAuthorized, Role } from '../../helpers/rolesHelper'
import { RootState } from '../../model/rootReducer'

function* saveBot(action: BotActionTypes) {
    try {
        if (action.payload.id) {
            yield call(Api.bots.update, action.payload as Bot)
            yield put(saveBotAction.success(action.payload))
        } else {
            const response = yield call(Api.bots.create, action.payload)
            yield put(saveBotAction.success(response.data as Bot))
        }
        notification.sucess('Bot sauvegardée avec succès')
    } catch (error) {
        yield put(saveBotAction.failure(error))
        notification.error(
            'Une erreur est survenue, veuillez réessayez ultérieurement'
        )
    }
}

function* exploreBot(action: BotActionTypes) {
    try {
        const userRoles = yield select<any>((state: RootState) =>
            selectUserRoles(state)
        )
        console.log(userRoles)
        if (isAuthorized(userRoles, Role.Builder)) {
            yield call(fillBotDatas, action.payload)
        }

        yield put(exploreBotAction.success(action.payload as string))
        navigate('/builder')
    } catch (error) {
        console.log(error)
        // TODO
    }
}

function* changeSelectedBot(action: BotActionTypes) {
    try {
        yield call(fillBotDatas, action.payload)
        yield put(changeSelectedBotAction.success(action.payload as string))
    } catch (error) {
        console.log(error)
        // TODO
    }
}

function* fillBotDatas(botId: string) {
    const responseFlows = yield call(Api.flows.get, botId)
    const responseEntities = yield call(Api.entities.get, botId)
    const responseIntents = yield call(Api.intents.get, botId)

    yield put(fillBotFlowsAction.success(responseFlows.data as Flow[]))
    yield put(fillEntities(responseEntities.data as Entity[]))
    yield put(fillIntents(responseIntents.data as Intent[]))
}

function* buildBot(action: BotActionTypes) {
    try {
        const botId = yield select((state) => state.bot.selectedBot)
        const response = yield call(Api.build.bot, botId)
        const type = response.headers['content-type']
        // @ts-ignore
        const blob = new Blob([response.data], { type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'build.txt'
        link.click()
    } catch (error) {}
}

export function* startBotsSagas() {
    yield all([
        takeLatest(saveBotActionType.request, saveBot),
        takeLatest(exploreBotActionType.request, exploreBot),
        takeLatest(changeSelectedBotActionType.request, changeSelectedBot),
        takeLatest(buildBotActionType, buildBot),
    ])
}
